import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { columnsProfesores } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AllTicketsHeader from './AllTicketsHeader';
import { dataProfesores } from 'data/apiConection.js/dataProfesores';

const TableViewProfesores = () => {
  const [profesores, setProfesores] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pr = await dataProfesores();
        setProfesores(pr);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <Row className="gx-0 mx-0" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {profesores && (
        <Col xxl={12} xl={12} style={{ height: '100%' }}>
          <AdvanceTableWrapper
            columns={columnsProfesores}
            data={profesores}
            selection
            selectionColumnWidth={52}
            sortable
            pagination
            perPage={80}
            rowCount={profesores.length}
          >
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Card.Header className="border-bottom border-200 px-0">
                <AllTicketsHeader title="Profesores" table layout="table-view" />
              </Card.Header>
              <Card.Body className="p-0" style={{ flexGrow: 1, overflowY: 'auto' }}>
                <AdvanceTable
                  table
                  headerClassName="bg-light text-800 align-middle"
                  rowClassName="btn-reveal-trigger align-middle"
                  tableProps={{
                    size: 'sm',
                    className: 'fs--1 mb-0 w-100 h-100',
                  }}
                />
              </Card.Body>
              <Card.Footer>
                <AdvanceTablePagination table />
              </Card.Footer>
            </Card>
          </AdvanceTableWrapper>
        </Col>
      )}
    </Row>
  );
};

export default TableViewProfesores;
